import Chip, { CHIP_COLORS } from "../../../../../../../components/chip/chip";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { SHIPMENT_STATUS_ENUM, SHIPMENT_STATUS_TRANSLATION_KEYS_MAP } from "../../../../rma-types";


interface IProps {
    statusCode: SHIPMENT_STATUS_ENUM;
    status: typeof SHIPMENT_STATUS_TRANSLATION_KEYS_MAP[keyof typeof SHIPMENT_STATUS_TRANSLATION_KEYS_MAP];
}

const StatusChipColorMap: { [key: string]: CHIP_COLORS } = {
    [SHIPMENT_STATUS_ENUM.PENDING_SHIPMENT]: CHIP_COLORS.ORANGE,
    [SHIPMENT_STATUS_ENUM.LABEL_CREATED]: CHIP_COLORS.ORANGE,
    [SHIPMENT_STATUS_ENUM.RECEIVED]: CHIP_COLORS.GREEN,
    [SHIPMENT_STATUS_ENUM.REJECTED]: CHIP_COLORS.RED,
}

const ShipmentStatusChip: React.FC<IProps> = ({ statusCode, status }) => {
    const { getTranslation } = useDashboardTranslation();
    return (
        <Chip label={getTranslation(status, 'dashboard-returns-rma-card')} color={StatusChipColorMap[statusCode] ?? CHIP_COLORS.DEFAULT} />
    )
};

export default ShipmentStatusChip;
